/**
 * Shell raiz do Terminal Kiosk — F8.2 (ADR-0023).
 *
 * Renderiza KioskShell fullscreen + Header com contexto + sub-rotas.
 *
 *   /producao/terminal           -> Login (PIN + estacao + unidade)
 *   /producao/terminal/bipar     -> Bipagem (requer sessao valida)
 *
 * Auto-redirect:
 *   - Se em /bipar mas sem sessao -> volta para /producao/terminal
 *   - Se em / mas com sessao valida -> vai para /bipar
 *
 * Sem AuthContext. Sem Sidebar. Sem Topbar do app principal.
 */

import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import Login from "./Login";
import Bipagem from "./Bipagem";
import {
  ExpiraEmIndicator,
  KioskHeader,
  KioskShell,
} from "./styles";
import {
  lerEstacao,
  lerExpiraEm,
  lerOperadorNome,
  lerPosto,
  temSessaoValida,
} from "./client";

function HeaderTerminal() {
  const [agora, setAgora] = useState(new Date());
  const operador = lerOperadorNome();
  const estacao = lerEstacao();
  const posto = lerPosto();
  const expira = lerExpiraEm();

  useEffect(() => {
    const t = setInterval(() => setAgora(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const segundosRestantes = expira ? Math.max(
    0,
    Math.floor((expira.getTime() - agora.getTime()) / 1000),
  ) : null;
  const alerta = segundosRestantes !== null && segundosRestantes < 120;

  return (
    <KioskHeader>
      <div className="marca">PharuERP — Terminal</div>
      <div className="ctx">
        {/* Sessão v2 mostra o POSTO (nome · etapa); sessão v1 antiga cai
            no fallback por estação até expirar. */}
        {posto ? (
          <span>
            Posto <strong>{posto.nome}</strong>
            {posto.etapa_label ? ` · ${posto.etapa_label}` : ""}
          </span>
        ) : estacao ? (
          <span>
            Estacao <strong>{estacao}</strong>
          </span>
        ) : null}
        {operador && <span>· {operador}</span>}
        <span>
          {agora.toLocaleTimeString("pt-BR", {
            hour: "2-digit", minute: "2-digit", second: "2-digit",
          })}
        </span>
        {segundosRestantes !== null && (
          <ExpiraEmIndicator $alerta={alerta}>
            Sessao expira em {Math.floor(segundosRestantes / 60)}m{" "}
            {segundosRestantes % 60}s
          </ExpiraEmIndicator>
        )}
      </div>
    </KioskHeader>
  );
}

function RotaProtegida({ children }) {
  if (!temSessaoValida()) {
    return <Navigate to="/producao/terminal" replace />;
  }
  return children;
}

function RotaLogin({ children }) {
  // Se ja tem sessao valida, pula login.
  if (temSessaoValida()) {
    return <Navigate to="/producao/terminal/bipar" replace />;
  }
  return children;
}

export default function TerminalShell() {
  return (
    <KioskShell>
      <HeaderTerminal />
      <Routes>
        <Route
          index
          element={
            <RotaLogin>
              <Login />
            </RotaLogin>
          }
        />
        <Route
          path="bipar"
          element={
            <RotaProtegida>
              <Bipagem />
            </RotaProtegida>
          }
        />
        {/* SS3.B.4 (M10, audit 2026-05-21): `to=""` cria possivel loop em
            certas versoes do react-router. Usar `to="."` (raiz da rota
            atual do shell, que ja eh /producao/terminal) ou path absoluto.
            "." resolve para o pathname pai do shell. */}
        <Route path="*" element={<Navigate to="." replace />} />
      </Routes>
    </KioskShell>
  );
}
